import React from 'react'

function Footer({ socialMedias, pageContent }) {
  return (
    <>
      {
        pageContent?.banner_footer &&
        <div className="footer_banner">
          <img src={pageContent?.banner_footer} loading="lazy" className="footer_banner-image" />
        </div>
      }

      <div className="section__dpo wf-section">
        <div className="center">
          <div className="dpo__container">
            <div className="dpo__columns w-row">
              <div className="dpo__left-column w-col w-col-2">
                <div className="dpo__title">DATA PROTECTION <br />OFFICER RESPONSÁVEL</div>
              </div>
              <div className="dpo__mid-column w-col w-col-6">
                <div className="dpo__description">Luiz Mattua - ens.lgpd@ens.edu.br <br />
                  Rua Senador Dantas, 74, Centro - Rio de Janeiro / RJ <br />
                  Somente assuntos relacionados à Lei Geral de Proteção de Dados (LGPD)</div>
              </div>
              <div className="dpo__right-column w-col w-col-4">
                <a href="https://emec.mec.gov.br/emec/consulta-cadastro/detalhamento/d96957f455f6405d14c6542552b0f6eb/MzcxMA==" target="_blank" className="selo-mec-link w-inline-block">
                  <img src="/assets/images/selo_mec.png" loading="lazy" alt="Selo MEC" className="selo__mec" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="section__footer wf-section">
        <div className="center">
          <div className="footer__container">
            <div className="footer_columns w-row">
              <div className="footer__column-logo w-col w-col-6 w-col-stack">
                <img src="/assets/images/Grupo-6417.png" loading="lazy" width="256" height="52" alt="" />
              </div>
              <div className="footer_column-content w-col w-col-6 w-col-stack">
                <div className="footer__social-media w-row">
                  <div className="social__whatsapp w-col w-col-4">
                    <div className="footer__title">Whatsapp</div>
                    <a href="#" className="social__box w-inline-block">
                      <img src="/assets/images/logo-whatsapp.svg" loading="lazy" width="16" height="16" alt="" className="footer__icon" />
                      <div className="footer__text">{pageContent?.contact_whatsapp}</div>
                    </a>
                  </div>
                  <div className="social__faleconosco w-col w-col-4">
                    <div className="footer__title">FALE CONOSCO</div>
                    <div className="social__box">
                      <img src="/assets/images/logo-whatsapp.svg" loading="lazy" width="16" height="16" alt="" className="footer__icon" />
                      <div className="footer__text">{pageContent?.contact_number}</div>
                    </div>
                  </div>
                  <div className="social__follow w-col w-col-4">
                    <div className="footer__title">SIGA NAS REDES</div>
                    <div className="social__box social__icons">
                      {
                        socialMedias?.map((item, index) => (
                          <a href={item.link} className="footer__social-link-block w-inline-block" key={index}>
                            <img src={item.icon} loading="lazy" width="16" height="16" alt={item.name} className="footer__icon" />
                          </a>
                        ))
                      }
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="section__footer-am4 wf-section">
        <img src="/assets/images/Caminho-8535.svg" loading="lazy" width="40" height="28" alt="" />
      </div>
    </>
  )
}

export default Footer